import { render, staticRenderFns } from "./DealEditor.vue?vue&type=template&id=3220f97b&scoped=true&"
import script from "./DealEditor.vue?vue&type=script&lang=ts&"
export * from "./DealEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DealEditor.vue?vue&type=style&index=0&id=3220f97b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220f97b",
  null
  
)

export default component.exports